export const FEATURED_PLAY = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FeaturedPlayWidgetElement';
